import { render, staticRenderFns } from "./bootCard.vue?vue&type=template&id=6b9084cf&scoped=true"
import script from "./bootCard.vue?vue&type=script&lang=js"
export * from "./bootCard.vue?vue&type=script&lang=js"
import style0 from "./bootCard.vue?vue&type=style&index=0&id=6b9084cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9084cf",
  null
  
)

export default component.exports